import { post, MakeRequestOptions } from './common';

export interface SendEventPayload {
  pageType: string;
  eventName: string;
  subtype: string;
  referrer?: string;
  properties: Record<string, any>;
}

export function sendEvent(
  payload: SendEventPayload,
  { cookies, userAgent }: MakeRequestOptions = {}
) {
  return post('analytics/event', payload, { cookies, userAgent });
}



// WEBPACK FOOTER //
// ./src/helpers/api/analytics.ts